import { initializeApp } from 'firebase/app';

const firebaseConfig = {
  apiKey: 'AIzaSyBGWFnfQb14Z4vC6yPQSqHCHQeKUVL4nV0',
  authDomain: 'haystyle-2e7d1.firebaseapp.com',
  databaseURL: 'https://haystyle-2e7d1-default-rtdb.firebaseio.com',
  projectId: 'haystyle-2e7d1',
  storageBucket: 'haystyle-2e7d1.appspot.com',
  messagingSenderId: '412442345691',
  appId: '1:412442345691:web:7854dd08c61e07ea188cfe',
};

// Initialize Firebase

const Fire = initializeApp(firebaseConfig);

export default Fire;
